import "./index.scss";

const Footer = () => {
  return <div className="footer">© {new Date().getFullYear()} Curious Labs, Inc All rights reserved.</div>;
};

export default Footer;
